import { render, staticRenderFns } from "./historic.vue?vue&type=template&id=3ae3dcd2&scoped=true&"
import script from "./historic.vue?vue&type=script&lang=js&"
export * from "./historic.vue?vue&type=script&lang=js&"
import style0 from "./historic.vue?vue&type=style&index=0&id=3ae3dcd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae3dcd2",
  null
  
)

export default component.exports